import { Component } from 'react';
import classnames from 'classnames';
import classNames from 'classnames/bind';

import styles from './styles.scss';

let cx = classNames.bind(styles);

export default class ServiceListItem extends Component {
  render() {
    let className = cx({
      serviceListItem: true,
    });

    return (
      <div className={classnames(className)} {...this.props}>
        {this.props.children}
      </div>
    );
  }
}
